import { Component, OnInit, Input, ChangeDetectorRef } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router } from "@angular/router"

import { ChangePasswordService } from '../../service/change-password.service';
import { Token } from '../../manager/token';
import { customValidation } from '../../manager/customValidators';
import { NotificationService } from 'src/app/service/notification.service';
import { ResponseHelper } from 'src/app/manager/response.helper';
import { LoginService } from 'src/app/service/login.service';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from '../../../environments/environment';
import { HeaderComponent } from 'src/app/common-components/header/header.component';
import { CommonModule } from '@angular/common';

 import { ColDef, GridOptions } from 'ag-grid-community';
import { AgGridModule } from 'ag-grid-angular';
import { BASE_AG_GRID_OPTIONS } from 'src/app/service/common-config';
@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss'],
  standalone: true,
    imports: [HeaderComponent, FormsModule, CommonModule, ReactiveFormsModule,AgGridModule]
})
export class ResetPasswordComponent implements    OnInit {
gridOptions: GridOptions = {
  pagination: true,
  paginationPageSize: 15,
  rowSelection : 'single',
    suppressColumnVirtualisation: true,
  suppressDragLeaveHidesColumns: true,
  ...BASE_AG_GRID_OPTIONS,
};


  title: string = "Reset Password";
  ResetPasswordForm: UntypedFormGroup;
  DisplayError: Boolean;
  DisableSubmit: Boolean = false;
  Token: Token;
  UserId: number;
  ResponseHelper;
  captchaArray = [];
  gradientColor = null;
  captchaData = '';

  showCaptcha: any;
  uniqueKey: any;
  isCaptcha: boolean= false;

  minLength: number;
  maxLength: number;
  constructor(private ChangePasswordService: ChangePasswordService, private cdr: ChangeDetectorRef, private notificationservice: NotificationService, private router: Router,
    public loginservice: LoginService,private sanitizer: DomSanitizer) {
    // this.Token = new Token(this.router);
    // var data = this.Token.GetUserData();
    // this.UserId = data.UserId;
  }


  ngOnInit() {
    this.createForm();
    // don't check if user logged in
    const UserID = sessionStorage.getItem('UserID');
    if (UserID != null) {
      this.ResetPasswordForm.patchValue({ User_Id: UserID });
      this.ResponseHelper = new ResponseHelper(this.notificationservice);
    }
    else {
      this.router.navigate(['/login']);
    }

    this.cdr.detectChanges();
  }

  createForm() {
    this.minLength = environment.passwordMinLength;
    this.maxLength = environment.passwordMaxLength;

    this.ResetPasswordForm = new UntypedFormGroup({
      User_Id: new UntypedFormControl(this.UserId, [Validators.required]),
      Old_Password: new UntypedFormControl('', [Validators.required
        // , Validators.minLength(12), Validators.maxLength(20)
      ]),
      New_Password: new UntypedFormControl('', [Validators.required
        , Validators.minLength(this.minLength), Validators.maxLength(this.maxLength),
      //Validators.pattern('(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?#&])[A-Za-z\d$@$!%*?#&].{7,}')
      Validators.pattern(`^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-/(/)/_/+/]).{${this.minLength},}$`)
      ]),
      confirmnewpass: new UntypedFormControl('', [Validators.required,
        // ,Validators.minLength(8), Validators.maxLength(20)
      ]),
      captchaData: new UntypedFormControl('',  [Validators.required]),
      UniqueKey: new UntypedFormControl('', null)
    }, { validators: [customValidation.MatchPassword, customValidation.NewPasswordMatchWithOld] });
    this.callCaptcha();

  }

  ResetPassword() {
    this.DisableSubmit = true;
    console.log('ResetPassword() : ', this.ResetPasswordForm.value);
    this.ResetPasswordForm.patchValue({ UniqueKey : this.uniqueKey });

    if (this.ResetPasswordForm.valid) {
      this.DisplayError = false;
      this.ChangePasswordService.ResetPasswrd(this.ResetPasswordForm.value)
        .subscribe(
          (data) => {
            console.log('ResetPasswrd data : ', data)
            this.ResponseHelper.GetSuccessResponse(data)
            setTimeout(() => {
              this.router.navigate(['/login']);
            }, 2000);
            this.DisableSubmit = false;
          }, err => {
            console.log('error : ', err);
            this.ResponseHelper.GetFaliureResponse(err)
            this.DisableSubmit = false;
            if(err.error != null){
            if(err.error.Data == null && err.error.Message[0].Message != 'Invalid captcha.') {
              this.callCaptcha();
            }
          }
          })
    }
    else {
      this.DisplayError = true;
      this.DisableSubmit = false;
    }
  }

  // Call API for Captcha
  callCaptcha(){
    this.isCaptcha = true;

    this.loginservice.loginCaptcha().subscribe((res:any)=> {
    this.isCaptcha = false;
    // this.ResponseHelper.GetSuccessResponse(res)
    let captcha = res.Data.responseCaptcha;
    this.uniqueKey = res.Data.UniqueKey;
    this.convertToImage(captcha);
    // this.captchaArray.push(this.showCaptcha)
    }, error => {
      this.ResponseHelper.GetFaliureResponse(error)
    })
    this.ResetPasswordForm.patchValue({ captchaData: '' })
    // this.ResetPasswordForm.controls.captchaData.setErrors(null);
  }

  convertToImage(captcha) {
    this.showCaptcha = this.sanitizer.bypassSecurityTrustResourceUrl(`data:image/png;base64, ${captcha}`);
    console.log(this.showCaptcha, 'this.showCaptcha');
  }
}
